import { CAMERA_CONFIG } from "../configs/CAMERA_CONFIG";
import gsap from "gsap";
import { useComponentLoadingStateStore } from "../store/useComponentLoadingStateStore";

export const animateCamera = (camera: THREE.Camera) => {
  if (camera === undefined || camera === null) return;
  const tl = gsap.timeline({
    onComplete: () =>
      useComponentLoadingStateStore.setState({
        isCameraResetAnimationFinished: true,
      }),
  });
  tl.to(
    camera.position,
    {
      x: 0,
      y: 32.81719943867427,
      z: 101.00095444860476,
      duration: 1,
    },
    0
  );
  tl.to(
    camera.rotation,
    {
      x: -0.3141592653589793,
      y: 0,
      z: 0,
      duration: 1,
    },
    0
  );
};

export const animateCameraZoom = (camera: THREE.Camera, zoomValue: number) => {
  const isChangingHall =
    useComponentLoadingStateStore.getState().isCameraScrollZoomEnabled;
  const isChangingHallMobile =
    useComponentLoadingStateStore.getState().areControlPanelButtonsDisabled;
  if (isChangingHall || isChangingHallMobile) return;
  if (camera === undefined || camera === null) return;
  gsap.to(camera.position, {
    z: CAMERA_CONFIG.position[2] - zoomValue,
    duration: 1,
  });
};
